import {useDropzone} from "react-dropzone";
import {useEffect, useState} from "react";
import "./ExerciseImage.css"

const ExerciseImage = ({index, source, onImageChange, onAnswerChange, answer}) => {
    const [preview, setPreview] = useState(null)

    useEffect(() => {
        if (source) {
            const objectUrl = URL.createObjectURL(source)
            setPreview(objectUrl);

            return () => {
                URL.revokeObjectURL(objectUrl);
            }
        } else {
            setPreview(null);
        }
    }, [source]);
    
    const onDrop = (items) => {
        onImageChange(items[0], index);
    }
    
    const {getRootProps, getInputProps, isDragActive} = useDropzone({onDrop, maxFiles: 1, accept: {
            'image/png': ['.png', '.jpg', '.jpeg'],
        }})

    const handleTextChange = (e) => {
        onAnswerChange(e.target.value, index);
    }
    
    return (
        <div className={"exerciseImage"}>
            <div {...getRootProps()}>
                <input {...getInputProps()} />
                <img src={preview || require('./image_placeholder.jpg')} 
                     alt={'placeholder'} 
                     className={"image"}/>
            </div>
            <input className={"input"} 
                   onChange={handleTextChange} 
                   value={answer || ''} 
                   placeholder={`Odpowiedź ${index + 1}`} 
            />
        </div>
    )
}

export default ExerciseImage;